/* WK CART SETTLE - the line that arrives before its variant does (2026-09-03).

   A custom rug is added by minting a throwaway Shopify variant (the pricing
   service's; Apippa's before 2026-09-16) and putting THAT in the cart. The
   variant often has not reached the storefront by the time the cart renders,
   so the line comes up with no image and a $0.00 price - on the cart page and
   in the drawer, which is built from the same markup on every page load. It
   resolved itself on the next refresh; now it resolves itself in place. Still
   observed with the native calculator (2026-09-30), so this stays.

   snippets/cart-item.liquid stamps such a line data-wk-pending (no image AND a
   zero price). This watches both cart forms' [data-products] for those lines,
   asks /cart.js on a short backoff whether the variant has landed (its image
   and price appear there first), and when it has, asks Impulse to rebuild the
   cart (the `cart:build` event both CartForms listen for) so the line renders
   through the real Liquid path - the trade gate, tier pricing and the
   dimensions block included - rather than being patched from JSON here. The
   settled line's image and price then fade up (wk-reveal, custom.css).

   Bounded: each line gets one round of the backoff (~40s), and the last try
   rebuilds regardless so the page reflects whatever the storefront knows. A
   line that never resolves (a genuinely free, imageless item) is simply left
   as rendered and never polled again this page. Every page, deferred, after
   theme.js and wk-unfold.js. */
(function () {
  'use strict';
  if (window.wkCartSettle) return;

  var DELAYS = [700, 1200, 2000, 3000, 4500, 6000, 8000, 8000, 8000];
  var lines = {};          /* key -> { tries, done } */
  var polling = false;
  var timer = null;
  var queued = false;

  function pendingKeys() {
    var out = [];
    [].forEach.call(document.querySelectorAll('.cart__item[data-wk-pending][data-key]'), function (el) {
      var k = el.getAttribute('data-key');
      var rec = lines[k] || (lines[k] = { tries: 0, done: false, rebuilding: false });
      if (!rec.done && !rec.rebuilding) out.push(k);
    });
    return out;
  }

  function landed(cart, key) {
    var it = null;
    for (var i = 0; i < cart.items.length; i++) if (cart.items[i].key === key) { it = cart.items[i]; break; }
    if (!it) return true;                                  /* removed meanwhile: nothing to wait for */
    var img = it.image || (it.featured_image && it.featured_image.url);
    return !!img && (it.price > 0 || it.final_price > 0 || it.original_price > 0);
  }

  /* landed rebuild (final=false): the variant reached /cart.js, so re-render
     and VERIFY - scan() confirms the fresh markup is no longer pending, and if
     a beat of storefront skew renders it pending again the key is freed to poll
     once more rather than being stranded on \"Confirming\". final=true: out of
     tries, give up and leave whatever the storefront now knows. */
  function rebuild(keys, final) {
    keys.forEach(function (k) {
      lines[k].settled = true;
      if (final) { lines[k].done = true; } else { lines[k].rebuilding = true; }
    });
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function poll() {
    timer = null;
    var keys = pendingKeys();
    if (!keys.length) { polling = false; return; }
    fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var landedKeys = [], exhausted = [], waiting = [];
        keys.forEach(function (k) {
          lines[k].tries++;
          if (landed(cart, k)) landedKeys.push(k);
          else if (lines[k].tries >= DELAYS.length) exhausted.push(k);   /* out of tries: rebuild once more, then leave it */
          else waiting.push(k);
        });
        if (landedKeys.length) rebuild(landedKeys, false);   /* verified in scan() */
        if (exhausted.length) rebuild(exhausted, true);      /* final */
        if (waiting.length) schedule(waiting); else polling = false;
      })
      .catch(function () {
        /* A failed fetch (5xx, maintenance, non-JSON) is a try too, or an unreachable
           /cart.js was polled every 700ms for as long as the tab lived (sweep 2026-10-07). */
        var exhausted = [], waiting = [];
        keys.forEach(function (k) { lines[k].tries++; (lines[k].tries >= DELAYS.length ? exhausted : waiting).push(k); });
        if (exhausted.length) rebuild(exhausted, true);
        if (waiting.length) schedule(waiting); else polling = false;
      });
  }

  function schedule(keys) {
    var most = 0;
    keys.forEach(function (k) { if (lines[k].tries > most) most = lines[k].tries; });
    timer = window.setTimeout(poll, DELAYS[Math.min(most, DELAYS.length - 1)]);
  }

  /* Runs after any cart markup lands: reveals what just settled, and starts
     the wait for anything still pending. */
  function scan() {
    queued = false;
    [].forEach.call(document.querySelectorAll('.cart__item[data-key]'), function (el) {
      var k = el.getAttribute('data-key');
      var rec = lines[k];
      if (!rec) return;
      /* a landed rebuild just re-rendered this line: if the fresh markup is
         resolved we are done; if it is still pending (storefront skew) free it
         to poll again rather than stranding it on \"Confirming\". */
      if (rec.rebuilding) {
        rec.rebuilding = false;
        if (!el.hasAttribute('data-wk-pending')) rec.done = true;
      }
      if (rec.settled && !el.hasAttribute('data-wk-pending') && !el.classList.contains('wk-cart-settled')) {
        el.classList.add('wk-cart-settled');
        rec.settled = false;
      }
    });
    if (!polling && pendingKeys().length) { polling = true; poll(); }
  }
  function scanSoon() {
    if (queued) return;
    queued = true;
    window.setTimeout(scan, 0);
  }

  function watch(root) {
    if (!root || root.__wkSettleWatched || !window.MutationObserver) return;
    root.__wkSettleWatched = true;
    new MutationObserver(scanSoon).observe(root, { childList: true, subtree: true });
  }

  function init() {
    var roots = document.querySelectorAll('#CartPageForm [data-products], #CartDrawerForm [data-products]');
    if (!roots.length) return;
    [].forEach.call(roots, watch);
    scanSoon();
  }

  window.wkCartSettle = { scan: scanSoon };
  init();
  document.addEventListener('shopify:section:load', init);
})();
